<template>
  <div class="animated fadeIn">
    <div class="block-screen" v-if="loading">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">Cadastrar Voo</div>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset label="Número do Grupo">
                <b-input-group>
                  <b-form-input
                    type="number"
                    v-model="group_number"
                    :class="{ 'is-invalid': $v.group_number.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Companhia Aérea">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="company"
                    :class="{ 'is-invalid': $v.company.$invalid }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Lugares disponíveis">
                <b-input-group>
                  <b-form-input type="text" v-model="available_places">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <!-- <b-col md="3">
              <b-form-fieldset label="Localizador">
                <b-input-group>
                  <b-form-input type="text" v-model="locator"> </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col> -->
            <b-col md="3">
              <b-form-fieldset label="Cidade">
                <b-input-group>
                  <b-form-input type="text" v-model="city"> </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
          </b-row>

          <b-row class="form-group">
            <b-col md="3">
              <label>Imagem dos voos</label>
              <input
                ref="fileupload"
                type="file"
                @change="filesChange($event.target.files)"
                accept="image/*"
              />
            </b-col>
            <b-col md="12" v-if="typeof this.attachment_binary === 'string'" class="mt-2">
              <img
                v-bind:src="'data:image/jpeg;base64,' + this.attachment_binary" width="100%"
              />
            </b-col>
          </b-row>

          <!-- <b-row class="form-group">
            <b-col md="12">
              <b><p>IDA:</p></b>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Número voo 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_flight_number_1"
                    :class="{
                      'is-invalid': $v.departure_flight_number_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Data">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_date_1"
                    :class="{
                      'is-invalid': $v.departure_date_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade de origem 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_incoming_city_1"
                    :class="{
                      'is-invalid': $v.departure_incoming_city_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Horário da ida 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_incoming_time_1"
                    :class="{
                      'is-invalid': $v.departure_incoming_time_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade da chegada 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_coming_city_1"
                    :class="{
                      'is-invalid': $v.departure_coming_city_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Horário da chegada 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_coming_time_1"
                    :class="{
                      'is-invalid': $v.departure_coming_time_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset label="Número voo 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_flight_number_2"
                    :class="{
                      'is-invalid': $v.departure_flight_number_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Data">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_date_2"
                    :class="{
                      'is-invalid': $v.departure_date_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade de origem 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_incoming_city_2"
                    :class="{
                      'is-invalid': $v.departure_incoming_city_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Horário da ida 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_incoming_time_2"
                    :class="{
                      'is-invalid': $v.departure_incoming_time_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade da chegada 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_coming_city_2"
                    :class="{
                      'is-invalid': $v.departure_coming_city_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Horário da chegada 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="departure_coming_time_2"
                    :class="{
                      'is-invalid': $v.departure_coming_time_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="12">
              <b><p>VOLTA:</p></b>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Número voo 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_flight_number_1"
                    :class="{
                      'is-invalid': $v.return_flight_number_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Data">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_date_1"
                    :class="{
                      'is-invalid': $v.return_date_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade de origem 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_incoming_city_1"
                    :class="{
                      'is-invalid': $v.return_incoming_city_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Horário da ida 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_incoming_time_1"
                    :class="{
                      'is-invalid': $v.return_incoming_time_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade da chegada 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_coming_city_1"
                    :class="{
                      'is-invalid': $v.return_coming_city_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Horário da chegada 1">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_coming_time_1"
                    :class="{
                      'is-invalid': $v.return_coming_time_1.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset label="Número voo 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_flight_number_2"
                    :class="{
                      'is-invalid': $v.return_flight_number_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Data">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_date_2"
                    :class="{
                      'is-invalid': $v.return_date_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade de origem 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_incoming_city_2"
                    :class="{
                      'is-invalid': $v.return_incoming_city_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Horário da ida 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_incoming_time_2"
                    :class="{
                      'is-invalid': $v.return_incoming_time_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade da chegada 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_coming_city_2"
                    :class="{
                      'is-invalid': $v.return_coming_city_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Horário da chegada 2">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="return_coming_time_2"
                    :class="{
                      'is-invalid': $v.return_coming_time_2.$invalid,
                    }"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
          </b-row> -->

          <b-row class="form-group">
            <b-col md="12 text-right">
              <b-button variant="default" @click="back">
                <i class="fa fa-arrow-left"></i>&nbsp; Voltar
              </b-button>
              <b-button variant="primary" @click="create($v.$invalid)">
                <i class="fa fa-check"></i>&nbsp; Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!--/.col-->
    </b-row>
    <!--/.row-->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import { maxLength } from "vuelidate/lib/validators";

export default {
  name: "store-flight",
  directives: {
    mask: AwesomeMask,
  },
  components: {},
  data() {
    return {
      loading: false,
      id: undefined,
      company: undefined,
      group_number: undefined,
      available_places: undefined,
      locator: undefined,
      attachment_binary: undefined,
      city: undefined,
      flightId: undefined,
    };
  },
  mounted() {
    this.flightId = this.$router.history.current.params.id;
    if (this.flightId) {
      this.loading = true;
      this.$http
        .get(`flights/edit/${this.flightId}`, {})
        .then((response) => {
          const { flight } = response.data;
          (this.id = flight.id),
            (this.company = flight.company),
            (this.available_places = flight.available_places),
            (this.group_number = flight.group_number),
            (this.attachment_binary = flight.attachment_binary),
            (this.city = flight.city),
            (this.locator = flight.locator);

          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.hasErrors = true;
          this.loading = false;
        });
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: "Voos",
      });
    },
    filesChange: function (fileList) {
      this.newUpload =
      this.attachment_binary = fileList[0];
    },
    create(isInvalid) {
      if (isInvalid === false) {
        this.loading = true;

        const formData = new FormData();
        const flight = {
          company: this.company,
          group_number: this.group_number,
          available_places: this.available_places,
          // locator: this.locator,
          attachment_binary: this.attachment_binary,
          city: this.city,
        };
        if (this.id !== undefined) {
          flight.id = this.id;
        }
        this.buildFormData(formData, flight);
        this.$http
          .post(`flights`, formData)
          .then(() => {
            this.loading = false;
            this.$router.push({
              name: "Voos",
            });
          })
          .catch((error) => {
            console.error(error);
            this.hasErrors = true;
            this.loading = false;
          });
      }
    },
    buildFormData: function (formData, data, parentKey) {
      if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
      ) {
        Object.keys(data).forEach((key) => {
          this.buildFormData(
            formData,
            data[key],
            parentKey ? `${parentKey}[${key}]` : key
          );
        });
      } else {
        const value = data == null ? "" : data;
        formData.append(parentKey, value);
      }
    },
  },
  validations() {
    return {
      group_number: { maxLength: maxLength(10) },
      company: { maxLength: maxLength(255) },
      available_places: {},
      locator: { maxLength: maxLength(100) },

      departure_flight_number_1: { maxLength: maxLength(100) },
      departure_flight_number_2: { maxLength: maxLength(100) },
      departure_date_1: { maxLength: maxLength(100) },
      departure_date_2: { maxLength: maxLength(100) },
      departure_incoming_city_1: { maxLength: maxLength(100) },
      departure_incoming_city_2: { maxLength: maxLength(100) },
      departure_incoming_time_1: { maxLength: maxLength(100) },
      departure_incoming_time_2: { maxLength: maxLength(100) },
      departure_coming_city_1: { maxLength: maxLength(100) },
      departure_coming_city_2: { maxLength: maxLength(100) },
      departure_coming_time_1: { maxLength: maxLength(100) },
      departure_coming_time_2: { maxLength: maxLength(100) },
      return_flight_number_1: { maxLength: maxLength(100) },
      return_flight_number_2: { maxLength: maxLength(100) },
      return_date_1: { maxLength: maxLength(100) },
      return_date_2: { maxLength: maxLength(100) },
      return_incoming_city_1: { maxLength: maxLength(100) },
      return_incoming_city_2: { maxLength: maxLength(100) },
      return_incoming_time_1: { maxLength: maxLength(100) },
      return_incoming_time_2: { maxLength: maxLength(100) },
      return_coming_city_1: { maxLength: maxLength(100) },
      return_coming_city_2: { maxLength: maxLength(100) },
      return_coming_time_1: { maxLength: maxLength(100) },
      return_coming_time_2: { maxLength: maxLength(100) },
    };
  },
};
</script>
<style>
.modal-lg {
  max-width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/views/flights/Store.vue